<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Yvkf7V/tc-custom/9781497685215.jpg?1734035679614" alt="This image is the cover for the book Lotus Crew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lotus Crew
      </h1>
      <p class="bookDescription body article font2">
        <b>Dope, duplicity, and violence fill this gasser of a novel from a protégé of William S. Burroughs </b><br/><br/> Set in the scorched cityscape of the Reagan-era Lower East Side of Manhattan, <i>The Lotus Crew</i> is Stewart Meyer’s harrowing yet humorous tale of loyalty and betrayal in the face of heroin addiction. Two street junkies, the introverted Alvira and the gregarious Tommy, team up to spark a street-retailing crew pushing the best heroin in town. In the abandoned buildings and back alleys of an Alphabet City that is as dangerous as the Wild West, the stamp of the Triad crew on a glassine bag of dope means it’s a smoker.<br/><br/> The duo is wildly successful until someone counterfeits the Triad seal and triggers a reaction from Tommy that leads to violence—and to a rude awakening for Alvira.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stewart Meyer
      </h2>
      
      <p class="authorDescription body article">Stewart Meyer was born in Brooklyn, New York. At age twelve he discovered Henry Miller&rsquo;s&#160;<I>Tropic of Cancer</I>&#160;in a used bookstore on Flatbush Avenue and decided to become a writer. He attended the City University of New York and audited William S. Burroughs&rsquo;s lecture series on creative writing. This led to a lifelong friendship with Mr. Burroughs and to an opportunity to observe a master writer going from draft to draft.<BR /><BR /> Meyer&rsquo;s first novel,&#160;<I>The Lotus Crew</I>, was originally published in 1984. He is currently at work on a second novel,&#160;<I>The Heist Broker</I>, and a memoir,&#160;<I>Memory Chips and Reconstituted Pebbles</I>. He lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cf98c19